<template>
  <exo-help-dialog title="Antenna transmitted power">
    <p>
      The transmitted power corresponds to the input power to be transmitted by
      that antenna. It will be used to compute the transmitter's
      <katex-element expression="\mathrm{EIRP}" />.
    </p>
    <tooltipEquationEIRP />
    <tooltipEquationEbN0 />
  </exo-help-dialog>
</template>

<script>
import tooltipEquationEbN0 from './tooltipEquationEbN0.vue'
import tooltipEquationEIRP from './tooltipEquationEIRP.vue'
export default {
  name: 'tooltipTransmittedPower',
  components: {
    tooltipEquationEbN0,
    tooltipEquationEIRP
  }
}
</script>
